import { createContext, useState } from "react";

export const SUBContext = createContext();

const intialSUBFilters = {
  status: "",
  amountMin: "",
  amountMax: "",
  serviceStartDateFrom: "",
  serviceStartDateTo: "",
};

export const SUBProvider = ({ children }) => {
  const [subSearchTerm, setSubSearchTerm] = useState("");
  const [ContextCurrentPage, contextSetCurrentPage] = useState(1);
  const [ContextTotalPages, contextSetTotalPages] = useState(0);
  const [ContextReload, ContextSetReload] = useState(false);
  const [Contextlimit] = useState(5);
  const [subFilters, setSubFilters] = useState(intialSUBFilters);

  return (
    <SUBContext.Provider
      value={{
        subSearchTerm,
        setSubSearchTerm,
        subFilters,
        setSubFilters,
        intialSUBFilters,
        ContextCurrentPage,
        contextSetCurrentPage,
        ContextTotalPages,
        contextSetTotalPages,
        Contextlimit,
        ContextReload,
        ContextSetReload,
      }}
    >
      {children}
    </SUBContext.Provider>
  );
};
